import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/redux/utils'

export interface Platform {
  id: number
  logo: string
  name: string
}

export interface ApiKey {
  id: number
  key: string
  secret: string
}

export interface ExternalApiKey extends ApiKey {
  platformId: number
}

export const readMineApiKey = 'readMineApiKey'
export const readMineExternalApiKey = 'readMineExternalApiKey'

export const apiKeySlice = createApi({
  reducerPath: 'apiKey',
  baseQuery,
  tagTypes: [readMineApiKey, readMineExternalApiKey],
  endpoints: builder => ({
    readAllPlatforms: builder.query<Platform[], void>({
      query: () => '/api-key/external/platforms/all',
    }),
    readMineApiKey: builder.query<ApiKey, void>({
      extraOptions: {
        errorToast: false,
      },
      providesTags: [readMineApiKey],
      query: () => ({
        url: '/api-key/axgrad/mine',
      }),
    }),
    applyApiKey: builder.mutation<ApiKey, void>({
      invalidatesTags: [readMineApiKey],
      query: () => ({
        url: '/api-key/axgrad/apply',
        method: 'POST',
      }),
    }),
    readMineExternalApiKey: builder.query<ExternalApiKey[], void>({
      providesTags: [readMineExternalApiKey],
      query: () => '/api-key/external/mine',
    }),
    createExternalApiKey: builder.mutation<ExternalApiKey, Omit<ExternalApiKey, 'id'>>({
      invalidatesTags: [readMineExternalApiKey],
      query: (body) => ({
        url: '/api-key/external',
        method: 'POST',
        body,
      }),
    }),
    removeExternalApiKey: builder.mutation<void, number>({
      invalidatesTags: [readMineExternalApiKey],
      query: (id) => ({
        url: `/api-key/external/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useReadAllPlatformsQuery,
  useReadMineApiKeyQuery,
  useReadMineExternalApiKeyQuery,
  useApplyApiKeyMutation,
  useCreateExternalApiKeyMutation,
  useRemoveExternalApiKeyMutation,
} = apiKeySlice
